import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';

interface Props {
  text?: any;
  style?: any;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      ...theme.typography.button,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.error.main,
      padding: '0 10px 0 10px',
      margin: '0px 4px 0px 4px',
      display: 'inline-table',
      borderRadius: 3,
      textTransform: 'inherit',
      fontSize: 13,
      fontWeight: 700,
      letterSpacing: -0.3,
    },
  }),
);

const Label: React.FC<Props> = ({ text, style }) => {
  const classes = useStyles();
  return (
    <span className={classes.root} style={style}>
      {text}
    </span>
  );
};

export default Label;
